import { List } from 'immutable';
import types from '../constants/actionTypes';

const activeFilters = (state, action) => {
  switch (action.type) {
    case types.activeFilters.SET_ACTIVE_FILTER:
      let filterIndex = state.get(action.filterOption).indexOf(action.id);
      if (filterIndex === -1) {
        state = state.update(action.filterOption, (filter) => filter.push(action.id));
      } else {
        state = state.update(action.filterOption, (filter) => filter.delete(filterIndex));
      }

      break;
    case types.activeFilters.SET_SEARCH_TERM:
      state = state.set('search', action.value);
      break;
    case types.activeFilters.SET_SEARCH_CITY:
      state = state.set('searchCity', action.value);
      break;
    case types.activeFilters.SET_SEARCH_STATE:
      state = state.set('searchState', action.value);
      break;
    case types.activeFilters.SET_SORT_ORDER:
      state = state.set('orderBy', action.orderBy)
                    .set('order', action.order);
      break;
    case types.activeFilters.CLEAR_SEARCH_TERM:
      state = state.set('search', '');
      break;
    case types.activeFilters.CLEAR_ALL_FILTERS:
      state = state.map(item => item = List());
      state = state.set('searchCity', '').set('searchState', '');
      break;
  }
  return state;
};

export default activeFilters;



/** WEBPACK FOOTER **
 ** ./reducers/activeFilters.js
 **/